import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { validateEmail } from 'resources/utilities';
import { Column, Row } from 'components/simpleFlexbox';
import ButtonComponent from 'components/form/ButtonComponent';
import FormComponent from 'components/form/FormComponent';
import CheckboxComponent from 'components/form/checkbox';
import FormInputComponent from 'components/form/input';

const useStyles = createUseStyles((theme) => ({
    buttonContainer: {
        flexGrow: 1,
        marginTop: 48,
        '& > button': {
            fontSize: 40,
            height: 80,
            margin: 0,
            width: '100%'
        },
        '@media (max-width: 1364px)': {
            marginTop: 36,
            '& button': {
                height: 46,
                fontSize: 24,
                padding: 8
            }
        }
    },
    container: {
        marginLeft: '-10vw',
        maxWidth: 460,
        alignSelf: 'center',
        '@media (max-width: 1364px)': {
            marginLeft: 0
        },
        '@media (max-width: 479px)': {
            maxWidth: 300
        }
    },
    innerContainer: {
        maxWidth: 390
    },
    inputRow: {
        marginBottom: 26,
        '& > div': {
            width: '100%',
            flexGrow: 1
        },
        '@media (max-width: 968px)': {
            marginBottom: 20,
            '& .input-text-container > label': {
                marginBottom: 8
            },
            '& .input-text-container > input': {
                height: 46
            }
        }
    },
    inputRowTwoColumns: {
        '& > div': {
            maxWidth: 'calc(50% - 11px)'
        }
    },
    title: {
        ...theme.typography.title,
        fontSize: 60,
        marginBottom: 72,
        textAlign: 'center'
    }
}));

function CreateAccountComponent({ errorMessage, onSubmit }) {
    const theme = useTheme();
    const classes = useStyles({ theme });

    function onLocalSubmit(payload) {
        try {
            window.gtag('event', 'conversion', {
                send_to: 'AW-10974718715/LF-MCMiW6d4DEPvVk_Eo',
                event_callback: () => {}
            });
        } catch (ex) {}
        try {
            window.lintrk('track', { conversion_id: 9853276 });
        } catch (ex) {}
        onSubmit(payload);
    }

    return (
        <Column className={classes.container}>
            <h1 className={classes.title} id='signup-free-title'>
                Start for free today
            </h1>
            {errorMessage && <span className='signup-error-message'>{errorMessage}</span>}
            <FormComponent onSubmit={onLocalSubmit}>
                <Row
                    horizontal='space-between'
                    className={[classes.inputRow, classes.inputRowTwoColumns].join(' ')}
                >
                    <FormInputComponent
                        label='First Name'
                        name='firstName'
                        required='Please provide a valid first name'
                        autoComplete='off'
                    />
                    <FormInputComponent
                        label='Last Name'
                        name='lastName'
                        required='Please provide a valid last name'
                        autoComplete='off'
                    />
                </Row>
                <Row horizontal='space-between' className={classes.inputRow}>
                    <FormInputComponent
                        type='email'
                        label='Email'
                        name='email'
                        required='Please provide a valid email address'
                        validate={(value) => validateEmail(value)}
                        pattern={{
                            value: /^[A-Z0-9._%+-/']+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: 'Please provide a valid email address'
                        }}
                        autoComplete='off'
                    />
                </Row>
                <Row horizontal='space-between' className={classes.inputRow}>
                    <FormInputComponent
                        label='Password'
                        name='password'
                        type='password'
                        required='Passwords must be at least 8 characters long and contain at least 1 lowercase letter, 1 uppercase letter, 1 number and one special character'
                        minLength={{
                            value: 8,
                            message:
                                'Passwords must be at least 8 characters long and contain at least 1 lowercase letter, 1 uppercase letter, 1 number and one special character'
                        }}
                        pattern={{
                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-“!@#%&/,><’:;|_~`])\S{6,99}$/,
                            message:
                                'Passwords must be at least 8 characters long and contain at least 1 lowercase letter, 1 uppercase letter, 1 number and one special character'
                        }}
                        autoComplete='off'
                        showErrorMessageBelow
                    />
                </Row>
                <div>
                    <CheckboxComponent
                        name='agree'
                        required='You must agree with the terms & conditions and privacy policy before creating an account'
                        noSelectableLabel
                        label={
                            <span className='signup-agree-label'>
                                I agree to the{' '}
                                <a
                                    href='https://dataro.io/privacy-policy-2/'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    Dataro Privacy Policy
                                </a>{' '}
                                and{' '}
                                <a
                                    href='http://dataro.io/terms-conditions/'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    Terms & Conditions
                                </a>
                            </span>
                        }
                    />
                </div>
                <Row vertical='center' className={classes.buttonContainer}>
                    <ButtonComponent id='create_account' type='submit' className='signup-button'>
                        Get started now
                    </ButtonComponent>
                </Row>
            </FormComponent>
        </Column>
    );
}

export default CreateAccountComponent;
